import React, { Dispatch, SetStateAction, useCallback, useId } from 'react';
import { Checkbox, ColumnsVisibleStateItem, Dropdown, Tooltip, useDropdown } from '@shared/UI';
import classNames from 'classnames';
import { RiTableLine } from 'react-icons/ri';
import './ColumnsControl.scss';

interface ColumnsControlProps {
    columnsVisibleState: ColumnsVisibleStateItem[];
    setColumnsVisibleState: Dispatch<SetStateAction<ColumnsVisibleStateItem[] | null>>;
    className?: string;
}

export const ColumnsControl: React.FC<React.PropsWithChildren<ColumnsControlProps>> = (props) => {
    const { columnsVisibleState, setColumnsVisibleState, className } = props;

    const { dropDownToggle, dropdownOptions } = useDropdown();

    const buttonClick = useCallback(() => {
        dropDownToggle();
    }, [dropDownToggle]);

    const checkboxClick = (dataField: string) => {
        setColumnsVisibleState(
            (prev) =>
                prev?.map((stateItem) => {
                    if (stateItem.dataField === dataField) {
                        return {
                            ...stateItem,
                            visible: !stateItem.visible,
                        };
                    }
                    return stateItem;
                }) || null,
        );
    };

    const id = useId();

    return (
        <div className={classNames('feature-table-columns-control', className)}>
            <RiTableLine
                data-tooltip-id={id}
                className='feature-table-columns-control__icon'
                onClick={buttonClick}
            />
            <Tooltip
                id={id}
                place='top-start'
                content='Manage columns'
            />
            <Dropdown
                dropdownOptions={dropdownOptions}
                dropdownPlacement='top-left'
                className='feature-table-columns-control__dropdown'
            >
                {columnsVisibleState.map((stateItem) => {
                    return (
                        <div
                            key={stateItem.dataField as string}
                            className='feature-table-columns-control__dropdown-item'
                        >
                            <Checkbox
                                label={stateItem.title}
                                checked={stateItem.visible}
                                onChange={() => checkboxClick(stateItem.dataField as string)}
                                className='feature-table-columns-control__checkbox'
                            />
                        </div>
                    );
                })}
            </Dropdown>
        </div>
    );
};
